import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityLogo, EntityLogoProps} from "../../../../core/components/logos/entity-logo";
import {Link} from "../../../../core/components/link/link";
import {APP} from "../../../../core/app/consts";
import {ACTION_TYPES} from "../../../../core/consts";
import {CompetitorViewModel} from "../../../../domain/common/competitor/models/competitor-view-model";
import {StandingsDestinationViewModel} from "../../../../domain/standings/models/destinations/standings.destinations.view-model";
import {StandingsWidgetController} from "../../standings-widget.controller";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {STANDINGS_WIDGET} from "../../standings-widget.consts";
import {StandingsWidgetCompetitorPosition} from "./standings-widget.competitor.position";
import {Image} from "../../../../core/components/image/image";
import {PointsDeductionsHammerRequestParams} from "../../../../core/icons/points-deductions.hammer.request-params";

export class StandingsWidgetCompetitorProps extends BaseProps {
  controller: StandingsWidgetController;
  row: StandingsDestinationViewModel;
  source: String;
}

export const StandingsWidgetCompetitorBadge = observer(({controller, row, source}: StandingsWidgetCompetitorProps) => {
  const {state} = controller;

  const {isSmallView, currentLinkModel, isCollapsed} = state;
  const {competitor, destination, hasPointsDeduction} = row;
  const {id, linkModel, domainModel, sport} = competitor;

  const logoProps: EntityLogoProps = {
    entity: competitor,
    className: classNames(styles.competitor_logo),
    width: isSmallView ? STANDINGS_WIDGET.ICONS.COMPETITOR_LOGO.mobile : STANDINGS_WIDGET.ICONS.COMPETITOR_LOGO.desktop,
    height: isSmallView ? STANDINGS_WIDGET.ICONS.COMPETITOR_LOGO.mobile : STANDINGS_WIDGET.ICONS.COMPETITOR_LOGO.desktop
  }

  const linkProps = {
    className: classNames(styles.competitor_link),
    onClick: () => onCompetitorClick(),
    model: linkModel,
    routeProps: {
      dataSource: {
        entity: domainModel
      }
    }
  }

  const onCompetitorClick = () => {
    controller.action(ACTION_TYPES.entityClick, {
      entityId: id,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[CompetitorViewModel.name],
      currentLinkModel,
      sportTypeId: sport.id,
      source
    });

    return true;
  }

  const destinationProps = {
    className: classNames(styles.table_row_destination),
    style: {
      backgroundColor: isCollapsed ? 'transparent' : ((destination?.color) || 'transparent'),
    }
  }

  const hammerProps = {
    src: new PointsDeductionsHammerRequestParams(12,12),
    className: classNames(styles.competitor_points_deduction_logo)
  }

  return (
    <Link {...linkProps}>
      <div {...destinationProps}/>
      <StandingsWidgetCompetitorPosition row={row}/>
      <EntityLogo {...logoProps}/>
      {
        hasPointsDeduction ? <Image {...hammerProps}/> : null
      }
    </Link>
  )
});
